let _ = t => t,
  _t,
  _t2;
import styled from 'academy-common-lib/utils/Styling';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Header } from 'foundations-components/transitional/components/Header';
import { PlayerPlayIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { View } from 'foundations-components/components/View';
import UsageTracker from '../../../../utils/UsageTracker';
import LearnWhileDoingButton from '../LearnByDoing/LearnByDoingButton';
import { useRequestLearnWhileDoing } from '../../hooks';
import { useShort } from '../../../shortContent/shortContentQueries';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FontColor = styledWithTheme.div(_t || (_t = _`
  color: ${0} !important;
  padding-bottom: ${0};
  div {
    display: block;
  }
`), ({
  theme
}) => theme.color['text-core-on-fill-default'], ({
  theme
}) => theme.space['500']);
const LearnByDoingCtaScreenStyle = styled.div.withConfig({
  displayName: "LearnByDoingCTAScreen__LearnByDoingCtaScreenStyle",
  componentId: "sc-1anatl4-0"
})(["position:relative;margin-bottom:-150px;"]);
const LearnByDoingCtaButtonContainer = styledWithTheme.div(_t2 || (_t2 = _`
  background-color: ${0};
  bottom: 150px;
  position: relative;
`), ({
  theme: trellisTheme
}) => trellisTheme.color['fill-accent-neutral-pressed']);
const LearnByDoingCtaScreen = ({
  backgroundImage,
  otgId
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const {
    short
  } = useShort(Number(otgId), !otgId);
  const videoType = short === null || short === void 0 ? void 0 : short.type;
  const {
    handlePlayHsVideo,
    handleDisableLearnWhileDoingScreen,
    isVideoPlayed,
    isVideoFinished
  } = useRequestLearnWhileDoing();
  const handlePlayInAcademy = () => {
    handlePlayHsVideo();
    handleDisableLearnWhileDoingScreen();
    UsageTracker.track('contentInteraction', {
      action: 'learn-by-doing-cta-play-in-academy-clicked',
      shortId: String(otgId),
      contentId: String(otgId),
      videoType
    });
  };
  return /*#__PURE__*/_jsx(LearnByDoingCtaScreenStyle, {
    "data-test-id": "learn-by-doing-cta-screen",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "learn-by-doing-cta-screen",
        onLoad: () => setImgLoaded(true),
        src: backgroundImage
      }), imgLoaded ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(LearnByDoingCtaButtonContainer, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          paddingBlock: "500",
          children: [/*#__PURE__*/_jsx(FontColor, {
            children: /*#__PURE__*/_jsxs("center", {
              children: [/*#__PURE__*/_jsx(Header, {
                paddingBlock: "300",
                title: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.learnByDoingHeading"
                }),
                use: "condensed"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.learnByDoing.subTextLearnByDoing"
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            children: [/*#__PURE__*/_jsx(LearnWhileDoingButton, {
              otgId: otgId
            }), /*#__PURE__*/_jsx(Button, {
              "data-test-id": "play-in-academy-button",
              onClick: handlePlayInAcademy,
              size: "medium",
              use: "secondary-ghost",
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                flexDirection: "row",
                gap: "200",
                children: [!isVideoFinished && isVideoPlayed ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.continueHere"
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.watchInAcademy"
                }), /*#__PURE__*/_jsx(IconCircle, {
                  backgroundColor: "fill-accent-orange-default",
                  borderWidth: "0",
                  icon: PlayerPlayIcon,
                  padding: "100",
                  size: "100"
                })]
              })
            })]
          })]
        })
      }) : /*#__PURE__*/_jsx(View, {
        blockSize: "600px",
        children: /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true,
          layout: "centered",
          padding: "1700",
          use: "spinner"
        })
      })]
    })
  });
};
export default LearnByDoingCtaScreen;